import React, { useState } from 'react';

import Utils from 'files/Utils.js';
import { grantConsent, denyConsent } from 'files/Analytics.js';

const FIRE = '#D63D1F';
const FIRE_GLOW = '#FF6B3D';
const SECONDARY_DARK = '#242F3F';
const MUTED_TEXT = '#6F6F6F';
const BORDER = 'rgba(220,220,220,0.6)';

// TODO: point this at the live privacy policy once published.
const PRIVACY_POLICY_URL = 'https://www.homesafenetwork.com/privacypolicy/';

/*
 * ConsentBanner
 *
 * GDPR / CCPA cookie-consent banner. Tracking is strictly opt-in: Firebase
 * Analytics stays off until the visitor clicks "Accept". `onResolved` is
 * called after either choice so the parent can dismiss the banner.
 */
const ConsentBanner = ({ onResolved }) => {

    const isMobile = Utils.isMobile();
    const [busy, setBusy] = useState(false);

    const onAccept = async () => {
        if(busy) {
            return;
        }
        setBusy(true);
        try {
            await grantConsent();
        } finally {
            onResolved();
        }
    }

    const onDecline = () => {
        if(busy) {
            return;
        }
        denyConsent();
        onResolved();
    }

    return (
        <div style={{
            backgroundColor: '#FFFFFF',
            borderTop: `2px solid ${FIRE}`,
            bottom: 0,
            boxShadow: '0 -8px 30px -10px rgba(0,0,0,0.25)',
            left: 0,
            position: 'fixed',
            right: 0,
            zIndex: 9800
        }}>
            <div style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? 16 : 24,
                margin: '0 auto',
                maxWidth: 1280,
                padding: isMobile ? '20px 16px' : '20px 24px',
                width: '100%'
            }}>
                <div style={{ flex: 1 }}>
                    <h4 style={{
                        color: SECONDARY_DARK,
                        fontFamily: '"Poppins", sans-serif',
                        fontSize: 16,
                        fontWeight: 600,
                        margin: '0 0 4px 0'
                    }}>{'We value your privacy'}</h4>
                    <p style={{
                        color: MUTED_TEXT,
                        fontFamily: '"Lato", sans-serif',
                        fontSize: 14,
                        lineHeight: 1.6,
                        margin: 0
                    }}>
                        {'We use cookies for analytics and advertising — to understand how visitors move through our booking process and to measure the performance of our ad campaigns. We never set these cookies until you agree. You can change your choice anytime via "Cookie Preferences" in the footer. See our '}
                        <a
                        href={PRIVACY_POLICY_URL}
                        target={'_blank'}
                        rel={'noopener noreferrer'}
                        style={{ color: FIRE, fontWeight: 600, textDecoration: 'underline' }}>{'Privacy Policy'}</a>
                        {'.'}
                    </p>
                </div>
                <div style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: 12,
                    width: isMobile ? '100%' : 'auto'
                }}>
                    <button
                    type={'button'}
                    onClick={onDecline}
                    disabled={busy}
                    style={{
                        backgroundColor: 'transparent',
                        border: `1px solid ${BORDER}`,
                        borderRadius: 999,
                        color: SECONDARY_DARK,
                        cursor: busy ? 'default' : 'pointer',
                        fontFamily: '"Poppins", sans-serif',
                        fontSize: 14,
                        fontWeight: 600,
                        height: 44,
                        padding: '0 28px',
                        width: isMobile ? '100%' : 'auto'
                    }}>{'Decline'}</button>
                    <button
                    type={'button'}
                    onClick={onAccept}
                    disabled={busy}
                    style={{
                        background: `linear-gradient(90deg, ${FIRE}, ${FIRE_GLOW})`,
                        border: 'none',
                        borderRadius: 999,
                        color: '#FFFFFF',
                        cursor: busy ? 'default' : 'pointer',
                        fontFamily: '"Poppins", sans-serif',
                        fontSize: 14,
                        fontWeight: 600,
                        height: 44,
                        opacity: busy ? 0.7 : 1,
                        padding: '0 32px',
                        width: isMobile ? '100%' : 'auto'
                    }}>{'Accept'}</button>
                </div>
            </div>
        </div>
    )
}

export default ConsentBanner;
